import React from "react";
import { Box, Skeleton, Card, useTheme } from "@mui/material";

const ProfileCardShimmer = () => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        p: 3,
        textAlign: "center",
        borderRadius: "4px",
        backgroundColor: "#001d3d",
        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
        border: "1px solid rgba(255,255,255,0.12)",
      }}
    >
      <Skeleton
        variant="circular"
        width={140}
        height={140}
        sx={{ mx: "auto", mb: 2 }}
      />
      <Skeleton variant="text" width="60%" height={40} sx={{ mx: "auto", mb: 1 }} />
      <Skeleton variant="text" width="80%" height={24} sx={{ mx: "auto", mb: 3 }} />
      <Skeleton variant="rectangular" width="100%" height={40} sx={{ mb: 2 }} />
      <Skeleton variant="rectangular" width="100%" height={40} />
    </Card>
  );
};

export default ProfileCardShimmer;